import { KJUR } from "jsrsasign";

export function tstParse(hex) {
    const parse = new KJUR.asn1.tsp.TSPParser();
    try {
        return parse.getResponse(hex);
    } catch (error) {
        return parse.getToken(hex);
    }
}

export default tstParse;
